define(
    'viewmodels/secured/shares/tabs/recipients/recipients',[
        "viewmodels/ViewModelNotification",
        "viewmodels/secured/shares/context",
        "providers/dataprovider",
        "i19n!i19n/strings"
    ],
    function (ViewModelNotification, ctx, dataProvider, i19n) {
        var grid = null;
        var $grid = null;

        var vm = new ViewModelNotification(
        {
            i19n: i19n,
            listOfDocuments: ko.observable(),
            shareid: ko.observable()

        });

        vm.activate = function () {
            var documentshareid = sessionStorage.getItem("documentsharedid");

            vm.shareid(documentshareid);
     
            if (grid) {
                grid.dataSource.read();
            }
        };
        vm.attached = function () {
            vm.notifications([]);

            $grid = $("#recipient-grid");            

            buildKendoGrid();

            var detailExportPromises = [];

            function buildKendoGrid() {
                var columns = [
                    { field: "documentShareRecipientId", hidden: true },
                    { field: "recipient", title: i19n.to.recipient, width: 200 },
                    { field: "organisation", title: i19n.to.organisation },
                    { field: "downloaded", title: i19n.to.downloaded, template: "#var field=downloaded# #= field != null ? kendo.toString(field,'g') : '' #", width: 170 }, //d MMM yyyy hh:mm tt
                    { title: '&nbsp;', template: kendo.template($("#recipient-command-template").html()), width: 80 },
                    //{
                    //    command: [{
                    //            text: i19n.to.resend,
                    //            click: function (e) {
                    //                e.preventDefault();

                    //                var itm = this.dataItem($(e.currentTarget).closest("tr"));

                    //                dataProvider.documents
                    //                .resendDocumentShareEmailLink(vm.shareid(), itm.documentShareRecipientId)
                    //                .done(function () {
                    //                    vm.notify(1, i19n.to.resendemaildocumentsharelinkdone);
                    //                })
                    //                .fail(function (e) {
                    //                    e.stopPropagation = true;
                    //                    vm.notify(e.error);
                    //                });

                    //                return false;
                    //            }
                    //        }
                    //    ],
                    //    title: '&nbsp;',
                    //    width: 80
                    //}
                ];                

                grid = $grid.kendoGrid({
                    excelExport: function (e) {
                        e.preventDefault();

                        var workbook = e.workbook;

                        $("#recipient-grid [data-role=grid]")
                        .each(function () {
                            $(this).data("kendoGrid").saveAsExcel();
                        });

                        $.when.apply(null, detailExportPromises)
                        .then(function () {
                            var detailExports = $.makeArray(arguments);

                            detailExports.sort(function (a, b) {
                                return a.masterRowIndex - b.masterRowIndex;
                            });

                            workbook.sheets[0].columns.unshift({ width: 30 });

                            //for (var i = 0; i < workbook.sheets[0].rows.length; i++) {
                            //    workbook.sheets[0].rows[i].cells.unshift({});
                            //}

                            for (var i = detailExports.length -1; i >= 0; i--) {
                                var masterRowIndex = detailExports[i].masterRowIndex + 1;
                                var sheet = detailExports[i].sheet;

                                for (var ci = 0; ci < sheet.rows.length; ci++) {                                    
                                    if (sheet.rows[ci].cells[0].value) {
                                        sheet.rows[ci].cells.unshift({});
                                    }
                                }

                                [].splice.apply(workbook.sheets[0].rows, [masterRowIndex + 1, 0].concat(sheet.rows));
                            }

                            kendo.saveAs({
                                dataURI: new kendo.ooxml.Workbook(workbook).toDataURL(),
                                fileName: "share-details-recipients.xlsx"
                            });
                        });
                    },
                    dataBound: function () {
                        detailExportPromises = [];
                        //this.expandRow(this.tbody.find("tr.k-master-row").first());
                        //this.expandRow(this.tbody.find("tr.k-master-row"));

                        resizeGrid();
                    },
                    dataSource: getKendoGridDataSource(),
                    resizable: true,
                    sortable: true,
                    detailTemplate: kendo.template($("#recipienttemplate").html()),
                    detailInit: detailInit,
                    columns: columns,
                    scrollable: true
                }).data("kendoGrid");

                $grid.off("click", ".k-grid-Resend", "**");
                $grid.on("click", ".k-grid-Resend", function (e) {
                    e.preventDefault();

                    var itm = grid.dataItem($(e.currentTarget).closest("tr"));

                    dataProvider.documents
                    .resendDocumentShareEmailLink(vm.shareid(), itm.documentShareRecipientId)
                    .done(function () {
                        vm.notify(1, i19n.to.resendemaildocumentsharelinkdone);
                    })
                    .fail(function (e) {
                        e.stopPropagation = true;
                        vm.notify(e.error);
                    });

                    return false;
                });
            };
            function detailInit(e) {
                var columns = [
                    { field: "documentId", hidden: true },
                    { field: "title", title: i19n.to.title },
                    { field: "extension", title: i19n.to.ext, width: 50 },
                    { field: "docId", title: i19n.to.docid, width: 100 },
                    { field: "downloaded", title: i19n.to.downloaded, template: "#var field=downloaded# #= field != null ? kendo.toString(field,'g') : '' #", width: 170 } //d MMM yyyy hh:mm tt
                ];

                var deferred = $.Deferred();
                var masterRowIndex = e.masterRow.index("#recipient-grid .k-master-row");

                detailExportPromises.push(deferred);

                $("<div/>")
                .appendTo(e.detailCell).kendoGrid({
                    excelExport: function (e) {
                        e.preventDefault();

                        deferred.resolve({
                            masterRowIndex: masterRowIndex,
                            sheet: e.workbook.sheets[0]
                        });
                    },
                    dataSource: getSubKendoGridDataSource(e.data.documents),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    sortable: true,
                    scrollable: true
                });
            }
            function getKendoGridDataSource() {
                var schema = {
                    model: {
                        id: "documentShareRecipientId",
                        fields: {
                            documentShareRecipientId: { type: "string" },
                            recipient: { type: "string" },
                            organisation: { type: "string" },
                            downloaded: { type: "date" }
                        }
                    }
                };

                return new kendo.data.DataSource({
                    transport: {
                        read: function (callbacks) {
                            vm.loadData(vm.shareid())
                            .done(function () {
                                callbacks.success(vm.listOfDocuments().recipients);

                                setTimeout(function () {
                                    resizeGrid();
                                }, 500);
                            })
                            .fail(function (e) {
                                console.error(e);
                            });                            
                        }
                    },
                    schema: schema,
                    pageSize: 999
                });

            };
            function getSubKendoGridDataSource(documents) {
                var schema = {
                    model: {
                        id: "documentId",
                        fields: {
                            documentId: { type: "string"},
                            title: { type: "string" },
                            extension: { type: "string" },
                            docId: { type: "string" },
                            downloaded: { type: "date" }
                        }
                    }
                };

                return new kendo.data.DataSource({
                    transport: {
                        read: function (callbacks) {
                            callbacks.success(documents);

                            setTimeout(function () {
                                resizeGrid();
                            }, 500);
                        }
                    },
                    schema: schema,
                    pageSize: 999
                });
            };
            function resizeGrid() {
                if (!$grid)
                    return;

                var newGridHeight = $("#share-document-details-content").outerHeight() - 355;

                //- $(".page-header").outerHeight()
                //-$(".page-content").outerHeight()

                $grid.height(newGridHeight);

                grid.resize();
            }

            $(window).on("resize", _.debounce(resizeGrid, 250));
        };
        vm.loadData = function (documentshareid) {
            var self = this;
            var d = $.Deferred();

            ctx
            .loadForSharedDocumentDetails(documentshareid)
            .done(function (data) {
                vm.listOfDocuments(data);

                d.resolve();
            })
            .fail(function (e) {
                d.reject('error loading in my share module : ' + e);
                console.log('error loading in my share module : ' + e);
            });

            return d.promise();
        };
        vm.exportToExcel = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                grid.expandRow(grid.tbody.find("tr.k-master-row"));
                grid.saveAsExcel();
                grid.collapseRow(grid.tbody.find("tr.k-master-row"));

                complete();
            }
        });

        return vm;
    }
 );

